/**
 * AvailabilityRhythmTable (BON-241) — the weekly rhythm editor: one row per
 * weekday, four coarse slots each. Sunday-first per the design.
 */
import { AVAILABILITY_SLOTS, SLOT_LABELS, type AvailabilitySlot } from '../../../api/availability';

import { WEEKDAYS, type RhythmDraft } from './availabilityModel';

export interface AvailabilityRhythmTableProps {
  draft: RhythmDraft;
  onChange: (weekday: number, slot: AvailabilitySlot) => void;
  disabled?: boolean;
}

function slotButtonStyle(selected: boolean): React.CSSProperties {
  return {
    flex: 1,
    padding: '6px 4px',
    fontSize: 11,
    fontWeight: selected ? 700 : 500,
    borderRadius: 6,
    cursor: 'pointer',
    border: `1px solid ${selected ? 'var(--nb-primary)' : 'var(--nb-border)'}`,
    background: selected ? 'var(--nb-primary-soft)' : 'var(--nb-surface)',
    color: selected ? 'var(--nb-primary)' : 'var(--nb-muted)',
  };
}

export function AvailabilityRhythmTable({
  draft,
  onChange,
  disabled = false,
}: AvailabilityRhythmTableProps) {
  return (
    <div role="group" aria-label="Weekly rhythm" style={{ display: 'grid', gap: 6 }}>
      {WEEKDAYS.map((day) => (
        <div key={day.weekday} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ width: 40, fontSize: 12, fontWeight: 600 }}>{day.short}</span>
          <div style={{ display: 'flex', gap: 6, flex: 1 }}>
            {AVAILABILITY_SLOTS.map((slot) => {
              const selected = draft[day.weekday] === slot;
              return (
                <button
                  key={slot}
                  type="button"
                  disabled={disabled}
                  aria-pressed={selected}
                  aria-label={`${day.label}: ${SLOT_LABELS[slot]}`}
                  onClick={() => onChange(day.weekday, slot)}
                  style={slotButtonStyle(selected)}
                >
                  {SLOT_LABELS[slot]}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
